import { a as addQueryParams, s as slugify } from "./addQueryParams-CbXuSGTY.js";
import { c as clearBodyNoScroll, g as getDrawerProps } from "./drawer-BfLuYH0y.js";
const isWindowDefined = () => typeof window !== "undefined";
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addQueryParams,
  clearBodyNoScroll,
  getDrawerProps,
  isWindowDefined,
  slugify
}, Symbol.toStringTag, { value: "Module" }));
export {
  isWindowDefined as a,
  index as i
};
//# sourceMappingURL=index-BYSTnSKO.js.map
